module.exports = __webpack_public_path__ + "static/dungeoneers_pack-fa17587e007488198be66c13540bbbf9.jpg";